<template>
  <section class="invoice-preview-wrapper">
    <component
      :is="isMobile && !isPrinting ? 'mobile-checkout' : 'desktop-checkout'"
      :quote="quote"
      :project="project"
      :items="items"
      :supplier-data="supplierData"
      :tax-info="taxInfo"
      :refetch="refetch"
    />
  </section>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { VBToggle } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import router from '@/router'
import MobileCheckout from '@/components/invoice/MobileCheckout.vue'
import DesktopCheckout from '@/components/invoice/DesktopCheckout.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    MobileCheckout,
    DesktopCheckout,
  },

  props: {
    quote: {
      type: Object,
      default() {
        return {}
      },
    },
    project: {
      type: Object,
      default() {
        return {}
      },
    },
    address: {
      type: Object,
      default() {
        return {}
      },
    },
    items: {
      type: Array,
      default() {
        return []
      },
    },
    supplierData: {
      type: Array,
      default() {
        return []
      },
    },
    taxInfo: {
      type: Object,
      default() {
        return {}
      },
    },
    refetch: {
      type: Function,
      default() {
        return 0
      },
    },
  },
  setup(props, { root }) {
    const store = root.$store
    const paymentDetails = ref({})

    // Invoice Description
    // ? Your real data will contain this information
    const printInvoice = () => {
      window.print()
    }

    const supplierRoles = ['suppler_admin', 'auctioneer']

    const currentUser = computed(() => store.state.auth.currentUser)

    function isValid(string) {
      if (typeof string === 'string') return string
      return ''
    }

    const taxAddress = computed(
      () => `${isValid(props.taxInfo.street)}, ${isValid(
        props.taxInfo.ext_number,
      )},
        ${isValid(props.taxInfo.postal_code)}, ${isValid(props.taxInfo.city)},
        ${isValid(props.taxInfo.state)}`,
    )

    const optionsBasedInRole = computed(() => {
      // Options for purchase order view
      if (router.currentRoute.name === 'purchaseOrder') {
        if (currentUser.value.role_name === 'admin') {
          return 'PurchaseOrderOptionsForAdmin'
        }
        if (currentUser.value.role_name === 'auctioneer') {
          return 'PurchaseOrderOptionsForAuctioneer'
        }
      }
      // Options for quote view
      if (currentUser.value.role_name === 'admin') {
        return 'CheckoutOptionsForAdmin'
      }
      if (supplierRoles.includes(currentUser.value.role_name)) {
        return 'CheckoutOptionsForSupplier'
      }
      return 'CheckoutOptionsForUser'
    })

    return {
      paymentDetails,
      printInvoice,
      optionsBasedInRole,
      taxAddress,
      currentUser,
    }
  },

  computed: {
    subtotal() {
      return this.items.reduce((prev, next) => ({
        total: parseFloat(prev.total) + parseFloat(next.total),
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/pages/app-invoice.scss';
</style>

<style lang="scss">
@media print {
  // Global Styles
  body,
  text,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    background: transparent !important;
    color: #000 !important;
  }

  .print-info{
    display: flex;
    flex-direction: row !important;
  }

  .showOnprint {
    display: block !important;
  }
  .pagebreak {
    clear: both;
    page-break-after: always;
  }
  nav.header-navbar {
    display: none;
  }
  .print-left-column {
    width: 100% !important;
    max-width: 100%;
    flex-grow: 1;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }

  .noprint {
    display: none;
  }
}
</style>
